import React, { useEffect, useRef } from "react";

// SASS
import "./Part14.scss";

// COMPONENTS
import Step from "../Step/Step";

// HELPERS
import animate from "../../utils/animate";

// LIBRARIES
import scrollama from "scrollama";

// ASSETS
import germ1Img from "../../assets/img/germ-1-white.svg";
import germ2Img from "../../assets/img/germ-2-white.svg";
import germ3Img from "../../assets/img/germ-3-white.svg";
import germ4Img from "../../assets/img/germ-4-white.svg";
import swipeImg from "../../assets/img/Sponge-Wipe.png";
import spongeImg from "../../assets/img/Sponge.png";

// FUNCTION EXPORT
export default function Part14({ step, setShowScrolldown }) {
  // SCROLLAMA INSTANCE
  const scrolly = scrollama();

  // ANIMATION STEP DATA
  const animationSequence = [
    {
      stepNumber: "0",
      height: null,
      description: "change bg color to #E5E5E5",
    },
    { stepNumber: "1", height: null, description: "fade in wipe container 1" },
    {
      stepNumber: "2",
      height: null,
      description: "fade out sponge1, fade in wipe container2",
    },
    {
      stepNumber: "3",
      height: null,
      description: "fade out sponge2, fade in wipe container3",
    },
  ];

  // REFS
  const germContainerEl = useRef(null);
  const wipeContainer1El = useRef(null);
  const wipeContainer2El = useRef(null);
  const wipeContainer3El = useRef(null);
  const sponge1El = useRef(null);
  const sponge2El = useRef(null);

  // RUN WHEN THE COMPONENT MOUNTS
  useEffect(() => {
    scrolly
      .setup({
        step: `.${step}`,
        debug: false,
        threshold: 1,
        progress: true,
      })
      .onStepEnter(({ element, direction }) => {
        const step = element.dataset.step;
        switch (step) {
          case "0": {
            animate.changeBodyBgColorDown("#E5E5E5", direction);
            animate.fadeInOnEnter(germContainerEl.current, direction);
            break;
          }
          case "1": {
            animate.fadeInOnEnter(wipeContainer1El.current, direction);
            break;
          }
          case "2": {
            animate.fadeInOnEnter(wipeContainer2El.current, direction);
            animate.fadeOutOnEnter(sponge1El.current, direction);
            break;
          }
          case "3": {
            animate.fadeInOnEnter(wipeContainer3El.current, direction);
            animate.fadeOutOnEnter(sponge2El.current, direction);
            if (direction === "down") setShowScrolldown(false);
            break;
          }
          default:
            break;
        }
      })
      .onStepProgress(({ element, progress }) => {
        const step = element.dataset.step;
        switch (step) {
          default:
            break;
        }
      })
      .onStepExit(({ element, direction }) => {
        const step = element.dataset.step;
        switch (step) {
          case "0": {
            animate.changeBodyBgColorUp("#FFFFFF", direction);
            animate.fadeOutOnExit(germContainerEl.current, direction);
            break;
          }
          case "1": {
            animate.fadeOutOnExit(wipeContainer1El.current, direction);
            break;
          }
          case "2": {
            animate.fadeOutOnExit(wipeContainer2El.current, direction);
            animate.fadeInOnExit(sponge1El.current, direction);
            break;
          }
          case "3": {
            animate.fadeOutOnExit(wipeContainer3El.current, direction);
            animate.fadeInOnExit(sponge2El.current, direction);
            if (direction === "up") setShowScrolldown(true);
            break;
          }
          default:
            break;
        }
      });
  }, [scrolly, step]);

  // CUSTOM FUNCTIONS

  return (
    <section className="wrapper">
      <div className="sticky-container">
        {/* STICKY */}
        <div className="part14">
          <div className="germs-container" ref={germContainerEl}>
            <div className="germ germ-1">
              <img src={germ1Img} alt="" className="img-fluid" />
            </div>
            <div className="germ germ-2">
              <img src={germ2Img} alt="" className="img-fluid" />
            </div>
            <div className="germ germ-3">
              <img src={germ3Img} alt="" className="img-fluid" />
            </div>
            <div className="germ germ-4">
              <img src={germ4Img} alt="" className="img-fluid" />
            </div>
            <div className="germ germ-5">
              <img src={germ1Img} alt="" className="img-fluid" />
            </div>
            <div className="germ germ-6">
              <img src={germ2Img} alt="" className="img-fluid" />
            </div>
            <div className="germ germ-7">
              <img src={germ3Img} alt="" className="img-fluid" />
            </div>
            <div className="germ germ-8">
              <img src={germ4Img} alt="" className="img-fluid" />
            </div>
            <div className="germ germ-9">
              <img src={germ1Img} alt="" className="img-fluid" />
            </div>
          </div>
          <div
            className="wipe-container wipe-container-1"
            ref={wipeContainer1El}
          >
            <div className="wipe-img">
              <img src={swipeImg} alt="" />
            </div>
            <div className="text">
              When you are aware of the <b>contact time</b>
            </div>
            <div className="sponge" ref={sponge1El}>
              <img src={spongeImg} alt="" className="img-fluid" />
            </div>
          </div>
          <div
            className="wipe-container wipe-container-2"
            ref={wipeContainer2El}
          >
            <div className="wipe-img">
              <img src={swipeImg} alt="" />
            </div>
            <div className="text">
              You can kill germs in the correct way to reduce their spread to
              other:
            </div>
            <div className="sponge" ref={sponge2El}>
              <img src={spongeImg} alt="" className="img-fluid" />
            </div>
          </div>
          <div
            className="wipe-container wipe-container-3"
            ref={wipeContainer3El}
          >
            <div className="wipe-img">
              <img src={swipeImg} alt="" />
            </div>
            <div className="text">
              <div className="line line-1">patients</div>
              <div className="line line-2">colleagues</div>
              <div className="line line-3">and people</div>
            </div>
            <div className="sponge">
              <img src={spongeImg} alt="" className="img-fluid" />
            </div>
          </div>
        </div>
      </div>

      {/* STEPS */}
      {animationSequence.map(({ stepNumber, height, description, offset }) => {
        return (
          <Step
            stepSection={step}
            stepNumber={stepNumber}
            stepDescription={description}
            height={height}
            key={stepNumber}
            offset={offset}
          />
        );
      })}
    </section>
  );
}
